import createIcon from '../../createIcon';

/**
 * @component @name CompassCalibration
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMjFDMTQuMjA5MSAyMSAxNiAxOS4yMDkxIDE2IDE3QzE2IDE0Ljc5MDkgMTQuMjA5MSAxMyAxMiAxM0M5Ljc5MDg2IDEzIDggMTQuNzkwOSA4IDE3QzggMTkuMjA5MSA5Ljc5MDg2IDIxIDEyIDIxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDEwLjA3QzEzLjk1IDEwLjA3IDE1LjcyIDEwLjg2IDE3IDEyLjE0TDIyIDcuMTRDMTkuNDQgNC41OSAxNS45IDMgMTIgM0M4LjEgMyA0LjU2IDQuNTkgMiA3LjE1TDcgMTIuMTVDOC4yOCAxMC44NyAxMC4wNSAxMC4wNyAxMiAxMC4wN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CompassCalibration = createIcon('CompassCalibration', [
  [
    'path',
    {
      d: 'M12 21C14.2091 21 16 19.2091 16 17C16 14.7909 14.2091 13 12 13C9.79086 13 8 14.7909 8 17C8 19.2091 9.79086 21 12 21Z',
      key: '1xchhz',
    },
  ],
  [
    'path',
    {
      d: 'M12 10.07C13.95 10.07 15.72 10.86 17 12.14L22 7.14C19.44 4.59 15.9 3 12 3C8.1 3 4.56 4.59 2 7.15L7 12.15C8.28 10.87 10.05 10.07 12 10.07Z',
      key: '1hwcoo',
    },
  ],
]);

export default CompassCalibration;
